module.exports = __webpack_public_path__ + "img/especialista2.19eb7be0.png";